module.exports = __webpack_public_path__ + "static/Adieu-Regular-515c05d7f55cba8b883dcb107f8ccdb8.woff";